/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper, NameField } from 'framework/ui/field';
import { EMPTY_VALUE_INDICATOR, useAsyncValue } from 'framework/utils';
import { InputLoader } from 'framework/ui/mui-builder';
import useEmployeeNamesService from '../employeeNames/employeeNamesService';
import EmployeeLink from '../EmployeeLink';

const EmployeeLinkFieldWithNameLoading = ({
  source,
  externalId,
  value,
  ignoredNameParts = [],
  ...props
}: FieldProps) => {
  const { getEmployeeNameDataById } = useEmployeeNamesService();
  const { getValue: getId } = useFieldHelper({ source });
  const id = externalId || value || getId();

  const employeeName = useAsyncValue(() => (id ? getEmployeeNameDataById(id) : Promise.resolve({})), [id]);

  const fieldValue =
    employeeName === null ? (
      <InputLoader />
    ) : (
      <EmployeeLink
        name={
          employeeName?.nameEn ? <NameField ignoredNameParts={ignoredNameParts} value={employeeName?.nameEn} /> : id
        }
        id={id}
        {...props}
      />
    );
  const displayedValue = id ? fieldValue : EMPTY_VALUE_INDICATOR;

  return <TextField value={displayedValue} {...props} />;
};

export default EmployeeLinkFieldWithNameLoading;
